// application based types
export const SET_MODULE_ENTRY_POINT = 'SET_MODULE_ENTRY_POINT' // injected by typo page
export const RESET_MODULE_ENTRY_ENTRY = 'RESET_MODULE_ENTRY_POINT' // use for change search type
export const SET_MOBILE_DEVICE = 'SET_MOBILE_DEVICE' // define user device
export const RESET_PREVIOUSLY_CACHE = 'RESET_PREVIOUSLY_CACHE' // force cache reset to avoid caching based bugs
export const SET_WANT_GOOGLE_MAPS = 'SET_WANT_GOOGLE_MAPS' // allow use of Google Maps
export const SET_BUILD_SPECS = 'SET_BUILD_SPECS' // client build

// search based types
export const SET_SEARCH_QUERY = 'SET_SEARCH_QUERY' // set all query params (query, location and distance)
export const SET_SEARCH_PARAMS = 'SET_SEARCH_PARAMS' // set all search params (and prevParams)
export const SET_DEFAULT_RADIUS = 'SET_DEFAULT_RADIUS' // for initial default radius
export const RESET_LOCATION_PARAM = 'RESET_LOCATION_PARAM' // location && radius
export const SET_SEARCH_RESULTS = 'SET_SEARCH_RESULTS' // persist the search results
export const SET_SEARCH_RESULTS_IS_BOOKED = 'SET_SEARCH_RESULTS_IS_BOOKED' // Toggle isBooked value
export const ADD_SEARCH_RESULTS = 'ADD_SEARCH_RESULTS' // Add search results
export const RESET_SEARCH = 'RESET_SEARCH' // remove persisted results && params
export const RESET_QUERY_PARAM = 'RESET_QUERY_PARAM' // query
export const UPDATE_SEARCH_RESULTS = 'UPDATE_SEARCH_RESULTS' // perform after filter selection
export const UPDATE_QSR_IDENTIFIER = 'UPDATE_QSR_IDENTIFIER' // use at bookmark fetchBookmarkDetails because resultTile rendering requires this values
export const SET_SEARCH_LOCATION_DISTANCE = 'SET_SEARCH_LOCATION_DISTANCE' // Add search results
export const SET_TYPE_SPECIFIC_SEARCH_PARAMS = 'SET_TYPE_SPECIFIC_SEARCH_PARAMS' // set the search params for a typ

// bookmark types
export const TOGGLE_BOOKMARK = 'TOGGLE_BOOKMARK' // triggers compare logic for search key and type (used on result lists)
export const SHOW_BOOKMARK_OVERLAY = 'SHOW_BOOKMARK_OVERLAY'
export const HIDE_BOOKMARK_OVERLAY = 'HIDE_BOOKMARK_OVERLAY'
export const FETCH_BOOKMARKS_COMPLETE = 'FETCH_BOOKMARKS_COMPLETE'
export const CLEAR_BOOKMARK_DETAILS = 'CLEAR_BOOKMARK_DETAILS'
export const REMOVE_BOOKMARK_FROM_DETAILS = 'REMOVE_BOOKMARK_FROM_DETAILS'
export const REMOVE_ONE_BOOKMARK = 'REMOVE_ONE_BOOKMARK' // do not require compare (used on bookmark and compare view)
export const SOURCE_TYPE_URL = 'url'
export const SOURCE_TYPE_LOCAL = 'local'

// filter based types
export const SET_FILTERS = 'SET_FILTERS' // set all possible filters after search request (NO USER SELECTION)
export const UPDATE_FILTERS = 'UPDATE_FILTERS' // updates only filters
export const SET_SORT_BY = 'SET_SORT_BY' // when sort by value changes
export const RESET_FILTERS = 'RESET_FILTERS' // clear all filters
export const UPDATE_SORTING = 'UPDATE_SORTING' // only qs search

// details types
export const FETCH_DETAILS_COMPLETE = 'FETCH_DETAILS_COMPLETE' // detail data complete
export const CLEAR_DETAILS = 'CLEAR_DETAILS' // clear detail data
export const SET_DISTANCE_DETAILS = 'SET_DISTANCE_DETAILS' // distance to search location (day and night care)

// API error handling
export const SHOW_API_ERROR = 'SHOW_API_ERROR' // show error info
export const HIDE_API_ERROR = 'HIDE_API_ERROR' // hide error info

// compare types
export const FETCH_COMPARE_ITEMS_COMPLETE = 'FETCH_COMPARE_ITEMS_COMPLETE' // loading bookmark items name is complete
export const TOGGLE_ACTIVE_COMPARE_ITEMS = 'TOGGLE_ACTIVE_COMPARE_ITEMS' // add or remove active compare item
export const RESET_COMPARE_STATE = 'RESET_COMPARE_STATE' // set to initial State
export const FETCH_COMPARE_DETAILS_COMPLETE = 'FETCH_COMPARE_DETAILS_COMPLETE' // details data for compare item
export const SET_ACTIVE_COMPARE_ELEMENTS = 'SET_ACTIVE_COMPARE_ELEMENTS' // change active Type (without data fetching)
export const REMOVE_ONE_RESULT_ITEM = 'REMOVE_ONE_RESULT_ITEM' // remove one result object from result array
